// src/pages/Browser/components/HowToConnectModal.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import './HowToConnectModal.css';

// Import images directly
import connectWalletImg from '../../../assets/connect-steps/connect-wallet.png';
import selectWalletConnectImg from '../../../assets/connect-steps/select-walletconnect.png';
import qrCodeImg from '../../../assets/connect-steps/qr-code.png';
import copyUriImg from '../../../assets/connect-steps/copy-uri.png';
import walletScanImg from '../../../assets/connect-steps/wallet-scan.png';
import enterUriImg from '../../../assets/connect-steps/enter-uri.png';
import confirmConnectionImg from '../../../assets/connect-steps/confirm-connection.png';

const HowToConnectModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  
  if (!isOpen) return null;

  return (
    <div className="connect-modal-overlay">
      <div className="connect-modal-content">
        <h2>{t('browser.howToConnect.title', 'How to Connect to a DApp')}</h2>
        
        <div className="connect-step-container">
          {/* Step 1: Click Connect Wallet in DApp */}
          <div className="connect-step">
            <div className="step-number">1</div>
            <div className="step-content">
              <div className="step-title">{t('browser.howToConnect.step1Title', 'Click "Connect Wallet" in the DApp')}</div>
              <div className="step-description">
                {t('browser.howToConnect.step1Description', 'Look for a "Connect Wallet" button in the DApp interface and click it to start the connection process.')}
              </div>
              <div className="step-image-container">
                <img 
                  src={connectWalletImg} 
                  alt="Click Connect Wallet" 
                  className="step-image" 
                />
              </div>
            </div>
          </div>
          
          {/* Step 2: Select WalletConnect */}
          <div className="connect-step">
            <div className="step-number">2</div>
            <div className="step-content">
              <div className="step-title">{t('browser.howToConnect.step2Title', 'Select WalletConnect')}</div>
              <div className="step-description">
                {t('browser.howToConnect.step2Description', 'From the list of available wallet options, find and select "WalletConnect".')}
              </div>
              <div className="step-image-container">
                <img 
                  src={selectWalletConnectImg} 
                  alt="Select WalletConnect" 
                  className="step-image" 
                />
              </div>
            </div>
          </div>
          
          {/* Step 3: Find the QR Code */}
          <div className="connect-step">
            <div className="step-number">3</div>
            <div className="step-content">
              <div className="step-title">{t('browser.howToConnect.step3Title', 'Find the QR Code')}</div>
              <div className="step-description">
                {t('browser.howToConnect.step3Description', 'A QR code will appear on the screen that you can scan with your wallet.')}
              </div>
              <div className="step-image-container">
                <img 
                  src={qrCodeImg} 
                  alt="Find the QR Code" 
                  className="step-image" 
                />
              </div>
            </div>
          </div>
          
          {/* Step 4: Copy the WalletConnect URI */}
          <div className="connect-step">
            <div className="step-number">4</div>
            <div className="step-content">
              <div className="step-title">{t('browser.howToConnect.step4Title', 'Copy the WalletConnect URI')}</div>
              <div className="step-description">
                {t('browser.howToConnect.step4Description', 'Click the copy button or copy link to copy the WalletConnect URI shown below the QR code.')}
              </div>
              <div className="step-image-container">
                <img 
                  src={copyUriImg} 
                  alt="Copy the WalletConnect URI" 
                  className="step-image" 
                />
              </div>
            </div>
          </div>
          
          {/* Step 5: Go to Wallet and Click Scan */}
          <div className="connect-step">
            <div className="step-number">5</div>
            <div className="step-content">
              <div className="step-title">{t('browser.howToConnect.step5Title', 'Go to Wallet and Click Scan')}</div>
              <div className="step-description">
                {t('browser.howToConnect.step5Description', 'In BitDog Wallet, go to the wallet page and tap the Scan button in the actions menu.')}
              </div>
              <div className="step-image-container">
                <img 
                  src={walletScanImg} 
                  alt="Go to Wallet and Click Scan" 
                  className="step-image" 
                />
              </div>
            </div>
          </div>
          
          {/* Step 6: Enter WalletConnect URI Manually */}
          <div className="connect-step">
            <div className="step-number">6</div>
            <div className="step-content">
              <div className="step-title">{t('browser.howToConnect.step6Title', 'Enter WalletConnect URI Manually')}</div>
              <div className="step-description">
                {t('browser.howToConnect.step6Description', 'Click "Enter WalletConnect URI Manually" and paste the connection code you copied earlier.')}
              </div>
              <div className="step-image-container">
                <img 
                  src={enterUriImg} 
                  alt="Enter WalletConnect URI Manually" 
                  className="step-image" 
                />
              </div>
            </div>
          </div>
          
          {/* Step 7: Confirm the Connection */}
          <div className="connect-step">
            <div className="step-number">7</div>
            <div className="step-content">
              <div className="step-title">{t('browser.howToConnect.step7Title', 'Confirm the Connection')}</div>
              <div className="step-description">
                {t('browser.howToConnect.step7Description', 'Review the connection details and click "Connect" to complete the connection with the DApp.')}
              </div>
              <div className="step-image-container">
                <img 
                  src={confirmConnectionImg} 
                  alt="Confirm the Connection" 
                  className="step-image" 
                />
              </div>
            </div>
          </div>
        </div>
        
        <button 
          className="close-button-connect"
          onClick={onClose}
        >
          {t('actions.gotIt', 'Got it!')}
        </button>
      </div>
    </div>
  );
};

export default HowToConnectModal;